/**
 * True for local CRA (`npm run dev`) or when explicitly enabled via env.
 * Production builds never show dummy data unless REACT_APP_USE_DUMMY_DATA=true.
 */
export function isTestEnvironment() {
  return (
    process.env.NODE_ENV === 'development'
    || process.env.REACT_APP_USE_DUMMY_DATA === 'true'
  );
}
